import EventBus from '@/services/EventBus';
import { languages } from '@/locales/index.js';
import Vue from 'vue';

function getLocale() {
  return Vue.prototype.$locale || 'fr';
}

export const toasters = {
  triggerError: (message = null) => {
    console.log('triggerError', message);
    const locale = getLocale();
    EventBus.$emit('Toast::Show', {
      message: message ? message : languages[locale].shared.forms.submit.error,
      shape: 'square',
      durationMs: 5000,
      colorClass: 'bg-danger'
    });
  },
  triggerSuccess: (message = null) => {
    const locale = getLocale();
    EventBus.$emit('Toast::Show', {
      message: message ? message : languages[locale].shared.forms.submit.success,
      shape: 'square',
      durationMs: 5000,
      colorClass: 'bg-success'
    });
  }
};
